import { vuexPaginationBase } from '@/store/compositionV2/utils/query/pagination'
import { vuexSearchBase } from '@/store/compositionV2/utils/query/search'
import { vuexSortBase } from '@/store/compositionV2/utils/query/sort'
import { vuexFilterBase } from '@/store/compositionV2/utils/query/filter'

const createState = () => ({
  expand: null,
  ...vuexPaginationBase.createState(),
  ...vuexSearchBase.createState(),
  ...vuexSortBase.createState(),
  ...vuexFilterBase.createState()
})

const createGetters = () => ({
  ...vuexPaginationBase.createGetters(),
  ...vuexFilterBase.createGetters()
})

const createMutations = () => ({
  ...vuexPaginationBase.createMutations(),
  ...vuexSearchBase.createMutations(),
  ...vuexSortBase.createMutations(),
  ...vuexFilterBase.createMutations()
})

const createActions = () => ({
  ...vuexPaginationBase.createActions(),
  ...vuexSearchBase.createActions(),
  ...vuexSortBase.createActions(),
  ...vuexFilterBase.createActions()
})

const vuexQueryBase = {
  createState,
  createGetters,
  createMutations,
  createActions
}

export {
  vuexQueryBase
}
